const __script_base__ = {
  name: 'UcProgressLine',
  props: {
    color: String,
    text: String,
    percentSantiy: String,
    lineWidth: {
      type: Number,
      default: 6
    }
  },
  computed: {
    percentStyle() {
      const color = this.color ? this.color : '';
      return `background-color:${color}; width: ${this.percentSantiy}%;`;
    }
  },
  methods: {}
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "uc-progress isLine"
  }, [_c("div", {
    staticClass: "uc-progress-lineBar",
    style: "height: " + _vm.lineWidth + "px"
  }, [_c("div", {
    staticClass: "uc-progress-bg",
    style: _vm.percentStyle
  })]), _vm._v(" "), !!_vm.text ? _c("div", {
    staticClass: "uc-progress-text"
  }, [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")]) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/Progress/LineProgress.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);